export default "__VITE_ASSET__LrQgEB7L__"